/**
 * Pubblicazione da associare (Amazon/eBay) passata alla pagina /marketplace/associa/:platform.
 * Sta in sessionStorage e non solo nello store `notify`: la pagina di partenza, smontandosi,
 * svuota lo store, e cosi' la pagina regge anche un refresh.
 */
const CHIAVE = 'marketplaceSync:notify';
let memoria = null;

export function salvaPubblicazione(notify) {
	memoria = notify;
	try {
		sessionStorage.setItem(CHIAVE, JSON.stringify(notify));
	} catch (e) {
		// niente sessionStorage: basta la memoria
	}
}

export function leggiPubblicazione() {
	try {
		return JSON.parse(sessionStorage.getItem(CHIAVE) || 'null') || memoria;
	} catch (e) {
		return memoria;
	}
}
